import React from "react";
import LoginContainer from "../containers/Login/loginContainer";

export default function LoginPage(){
    return (
        <LoginContainer />
    )
}